export default class Observable<T> {
  private value: T;
  private subscribers: (() => void)[] = [];

  constructor(initialValue: T) {
    this.value = initialValue;
  }

  get(): T {
    return this.value;
  }

  set(newValue: T): void {
    this.value = newValue;
    this.notify();
  }

  subscribe(callback: () => void): void {
    this.subscribers.push(callback);
  }

  private notify(): void {
    this.subscribers.forEach((cb) => cb());
  }
}
